(function (angular, app) {
    "use strict";

    angular.module(app.modules.member.name)
       .controller(app.modules.member.routes.profile.controller, ProfileController);

    ProfileController.$inject = ["$scope", "$routeParams", "$q"
       , app.modules.common.constants.appmessaging
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.common.constants.regionlist
       , app.modules.common.constants.countrylist
       , app.modules.ui.services.alerts
       , "Media"
    ];

    function ProfileController($scope, $routeParams, $q
        , ggMessages
        , ggFunctions
        , ggStorage
        , ggRegions
        , ggCountries
        , ggAlertSvc
        , ggMedia
        ) {

        $scope.PopupAlert = new ggAlertSvc.popup;
        $scope.InlineAlert = new ggAlertSvc.inline;

        $scope.Tabs = {
            current: "Account"
           , select: function (tab) {
               if (tab) {
                   $scope.Tabs.current = tab;
                   if (tab == "Preferences") {
                       $scope.Preference.fetch();
                   }
                   if (tab == "Transactions") {
                       $scope.Transactions.fetch();
                   }
               }
           }
           , isActive: function (tab) {
               if (tab == $scope.Tabs.current) {
                   return true;
               }
           }
        }

        $scope.Temp = {
            profile: {
                isUpdate: false
            }
        }

        $scope.Data = {
            RegionList: ggRegions
           , CountryList: ggCountries
        }

        // Account Info
        $scope.Account = {
            isDirty: false
           , isPasswordMatching: function () {
               var ipm = false;
               if ($scope.Account.form.password != "" && $scope.Account.form.repassword != "") {
                   if ($scope.Account.form.password == $scope.Account.form.repassword) {
                       ipm = true;
                   }
               } else {
                   ipm = true;
               }
               return ipm;
           }
           , isValidEmail: function (e) {
               return ggFunctions.isEmailValid(e);
           }
           , isEmailUser: app.Member.Detail.email == app.Member.Detail.userName
           , save: function (isValid) {

               $scope.Account.isDirty = true;

               if ($scope.Account.form.password != "") {
                   if ($scope.Account.form.password != $scope.Account.form.repassword) {
                       isValid = false;
                       $scope.Account.alert = "The passwords you entered do not match"
                   }
               } else {
                  // $scope.Account.form.password = app.Member.Detail.password;
               }

               // If user and email are the same, sync.
               if ($scope.Account.isEmailUser) {
                   $scope.Account.form.userName = $scope.Account.form.email;
               }


               if ($scope.Account.form.mobilePhone == '') {
                   $scope.Account.form.mobilePhone = null;
               }

               if (isValid) {

                   var form = angular.copy($scope.Account.form);



                   ggFunctions.toggleProcessing(true);
                   app.Member.Network.SaveAccountDetail(form).then(function (data) {
                       if (data && data.status == "200") {

                           var memberships = angular.copy(app.Member.Detail.memberships);
                           app.Member.Detail = data.data;
                           app.Member.Detail.memberships = memberships; // memberships is not included in return

                           $scope.Account.form.password = "";
                           $scope.Account.form.repassword = "";
                           $scope.Account.isDirty = false;
                           $scope.PopupAlert.success("Saved!", ggMessages.member.profile.success);
                           $scope.Temp.profile.isUpdate = false;
                           app.Member.Authenticate.Broadcast();
                       } else {
                           $scope.PopupAlert.fail("Error", "There was an error processing your request.");
                       }
                   }, function (e) {
                       $scope.Account.form.password = "";
                       $scope.Account.form.repassword = "";
                       $scope.PopupAlert.fail("Error", "There was an error processing your request.");
                       console.log(e.data);
                   }).finally(function () { ggFunctions.toggleProcessing(false); });

               }


           }
           , form: {
               id: app.Member.Detail.id
              , email: app.Member.Detail.email
               , userName: app.Member.Detail.userName
               , password: ""
               , repassword: ""
               , firstName: app.Member.Detail.firstName
               , lastName: app.Member.Detail.lastName
               , mobilePhone: app.Member.Detail.mobilePhone
               , gender: app.Member.Detail.gender ? (app.Member.Detail.gender).substring(0,1) == "M" ? "Male" : "Female" : "M"
               , dateOfBirth: app.Member.Detail.dateOfBirth
               , address: {
                   line1: app.Member.Detail.address.line1 || ""
                  , line2: app.Member.Detail.address.line2 || ""
                  , city: app.Member.Detail.address.city || ""
                  , region: app.Member.Detail.address.region || ""
                  , postalCode: app.Member.Detail.address.postalCode || ""
                  , country: app.Member.Detail.address.country || "US"
               }
              , commSettings: {
                  memberListingPublic: app.Member.Detail.commSettings.memberListingPublic || true
                 , memberInfoPublic: app.Member.Detail.commSettings.memberInfoPublic || true
                 , allowNotifications: app.Member.Detail.commSettings.allowNotifications || true
                 , allowPrintNewsletters: app.Member.Detail.commSettings.allowPrintNewsletters || true
              }
           }


        }


        $scope.Preference = {
            form: {
                holesPlayed: "EighteenHoles"
               , courseObj: {}
               , groupId: 0
               , groupObj: {}
               , isChanged : false
               , preferenceSettings: {
                  trackStats : false
                  , trackStrokesGained : false
                  , postHoleByHole : true
                  , trackPutting: true
                  , trackPenalties: true
                  , trackClub: true
                  , trackDriveDistance: true
                  , trackFairways: true
                  , trackUpDown: true
                  , trackSandies: true
                  , trackPuttLength: true
                  , defaultCourseId : 0
                  , defaultTeeId : 0


               }
            }
           , fetch: function () {
               $scope.Preference.form.preferenceSettings = angular.copy(app.Member.Detail.preferenceSettings);
               


               // These items are local
               $scope.Preference.form.holesPlayed = ggStorage.get(ggStorage.keys.member.prefs.holesPlayed) || app.modules.scoring.constants.holesPlayed.eighteenHoles;
               $scope.Preference.form.courseObj   = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.course.courseObj)) || {};
               $scope.Preference.form.groupId = ggStorage.get(ggStorage.keys.member.prefs.group.groupId) || null;
               $scope.Preference.form.groupObj    = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.group.groupObj)) || {};
           }
           , update: function () {
               $scope.Preference.form.isChanged = true;
           }
            , save: function () {


                var form = angular.copy($scope.Account.form);
                form.preferenceSettings = angular.copy($scope.Preference.form.preferenceSettings);


                ggFunctions.toggleProcessing(true);
                app.Member.Network.SaveAccountDetail(form).then(function (data) {
                    if (data && data.status == "200") {

                        var memberships = angular.copy(app.Member.Detail.memberships);
                        app.Member.Detail = data.data;
                        app.Member.Detail.memberships = memberships; // memberships is not included in return


                        if ($scope.Preference.form.courseObj && $scope.Preference.form.preferenceSettings.defaultCourseId) {
                            ggStorage.set(ggStorage.keys.member.prefs.course.courseObj, $scope.Preference.form.courseObj);
                        }
                        if ($scope.Preference.form.groupObj && $scope.Preference.form.groupObj.groupId) {
                            ggStorage.set(ggStorage.keys.member.prefs.group.groupObj, $scope.Preference.form.groupObj);
                        }
                        
                        ggStorage.set(ggStorage.keys.member.prefs.group.groupObj, $scope.Preference.form.groupObj);

                        $scope.Preference.form.isChanged = false;
                        $scope.PopupAlert.success("Saved!", ggMessages.member.profile.success);
                        app.Member.Authenticate.Broadcast();
                    } else {
                        $scope.PopupAlert.fail("Error", "There was an error processing your request.");
                    }
                }, function (e) {
                    $scope.Account.form.password = "";
                    $scope.Account.form.repassword = "";
                    $scope.PopupAlert.fail("Error", "There was an error processing your request.");
                    console.log(e.data);
                }).finally(function () { ggFunctions.toggleProcessing(false); });

                


            }
            , statisticTypes: [{ value: false, name: 'Traditional' }, { value: true, name: 'Strokes Gained' }]
        }

        $scope.Transactions = {
            isSearch: false
           , isLoaded: false
           , customerId: ""
           , orders: []
           , prepaidcodes: []
           , stripe: null
           , fetch: function () {

               if (!$scope.Transactions.isSearch) {
                   var _fetchToken = function () {
                       return app.Member.Network.FetchAuthToken();
                   }
                   var _fetchDetail = function () {
                       if (app.Member.Auth.authToken) {
                           return app.Member.Network.FetchStripeCustomerDetail().then(function (data) {
                               if (data) {
                                   $scope.Transactions.customerId = data.data.sourceUserId;
                                   $scope.Transactions.orders = data.data.orders;
                                   $scope.Transactions.prepaidcodes = data.data.prepaidcodes;
                                   $scope.Transactions.stripe = data.data.stripe;

                               }
                           }, function (fail) {
                               $scope.PopupAlert.fail("Error", "There was an error fetching the customer deail: " + fail.data.error.msg);
                               return;
                           }).finally(function () {
                               $scope.Transactions.isLoaded = true;
                               $scope.Transactions.isSearch = true;
                           });
                       } else {
                           return $q.resolve();
                       }

                   }

                   _fetchToken().then(function () {
                       return _fetchDetail();
                   }).finally(function () {
                       $scope.Temp.upgrade.isSearch = true;
                   });
               }
           }
        }

        $scope.Content = {
            init: function () {

                // Mobile Phone
                if (app.Member.Detail.mobilePhone && app.Member.Detail.mobilePhone != "") {
                    if (isNaN(app.Member.Detail.mobilePhone)) {
                        $scope.Temp.profile.isUpdate = true;
                    }
                }

                // EmailAddress
                if (!app.Member.Detail.email || (app.Member.Detail.email && !ggFunctions.isEmailValid(app.Member.Detail.email))) {
                    $scope.Temp.profile.isUpdate = true;
                }

                // FirstName // LastName
                if (!app.Member.Detail.firstName || (app.Member.Detail.firstName && app.Member.Detail.firstName == "")) {
                    $scope.Temp.profile.isUpdate = true;
                }
                if (!app.Member.Detail.lastName || (app.Member.Detail.firstName && app.Member.Detail.lastName == "")) {
                    $scope.Temp.profile.isUpdate = true;
                }

                // address -- At least City, PostalCode
                if (!app.Member.Detail.address.postalCode || (app.Member.Detail.address.postalCode && app.Member.Detail.address.postalCode == "")) {
                    $scope.Temp.profile.isUpdate = true;
                }
                if (!app.Member.Detail.address.region || (app.Member.Detail.address.region && app.Member.Detail.address.region == "")) {
                    $scope.Temp.profile.isUpdate = true;
                }
                if (!app.Member.Detail.address.city || (app.Member.Detail.address.city && app.Member.Detail.address.city == "")) {
                    $scope.Temp.profile.isUpdate = true;
                }



                if ($scope.Temp.profile.isUpdate) {
                    $scope.Tabs.select("Account");
                    $scope.Account.isDirty = true;

                    $scope.$watch('frmAccount', function (frmAccount) {
                        $scope.frmAccount.email.$setDirty();
                        $scope.frmAccount.firstName.$setDirty();
                        $scope.frmAccount.lastName.$setDirty();
                        $scope.frmAccount.mobilePhone.$setDirty();
                        $scope.frmAccount.line1.$setDirty();
                        $scope.frmAccount.city.$setDirty();
                        $scope.frmAccount.region.$setDirty();
                        $scope.frmAccount.postalcode.$setDirty();
                    });
                }

            }
            , picture: {
                form: {
                    current: app.Member.Detail["photo@odata.mediaReadLink"]
                   , buffer: null
                   , media: null
                   , file: null
                   , contentType: app.Member.Detail["photo@odata.mediaContentType"]
                }
              , uploaded: {
                  image: null
                 , blob: null
                 , isLoading: false
              }
              , save: function () {
                  ggFunctions.toggleProcessing(true);

                  var saveImage = function () {
                      return ggMedia.insert({ url: app.Member.Detail["photo@odata.mediaEditLink"], buffer: $scope.Content.picture.uploaded.blob }).$promise
                  }

                  ggFunctions.toggleProcessing(true);
                  saveImage().then(function (data) {
                      if (data) {
                          $scope.Content.picture.form.current = URL.createObjectURL($scope.Content.picture.uploaded.blob);
                          $scope.Content.picture.reset();
                          
                          app.Member.Detail["photo@odata.mediaReadLink"] = $scope.Content.picture.form.current;

                          $scope.PopupAlert.success("Saved!", "Your picture has been updated.");
                      } else {
                          $scope.PopupAlert.fail("Error", "There was an error processing your request.");
                      }
                  }, function (e) {
                      $scope.PopupAlert.fail("Error", e.data.error.msg);
                  }).finally(function () {
                      ggFunctions.toggleProcessing(false);

                  });
              }
              , reset: function () {
                  $scope.Content.picture.uploaded.image = null;
                  $scope.Content.picture.uploaded.blob = null;
              }
            }
        }


        $scope.f = {
            updateBirthday: function (data) {
                if (data.date) {
                    $scope.Account.form.dateOfBirth = data.date;
                }
            }
           , updateCourse: function (course, tee) {
               if (course && tee) {
                   // Only the tee has the holes
                   if (course.tees) {
                       for (var t = 0; t < course.tees.length; t++) {
                           if (course.tees[t].id == tee.id) {
                               course.tees[t] = tee;
                           }
                       }
                   }
               }

               if (course && course.id) {
                   $scope.Preference.form.courseObj = course;
                   $scope.Preference.form.preferenceSettings.defaultCourseId = course.id;
                   $scope.Preference.form.isChanged = true;
               }
               if (tee && tee.id) {
                   $scope.Preference.form.preferenceSettings.defaultTeeId = tee.id;
                   $scope.Preference.form.isChanged = true;
                   
               }

           }
           , updateGroup: function (group) {
               if (group && group.id && group.id != $scope.Preference.form.groupId) {
                   $scope.Preference.form.groupObj = group;
                   $scope.Preference.form.groupId = group.id;

               }
           }
           , upload: function (e) {
                var file = e.target.files[0],
                    uploaded = $scope.Content.picture.uploaded,
                    options = { maxWidth: 320, maxHeight: 320, orientation: true };

                uploaded.isLoading = true;
                loadImage(file, imageCallback, options);

                function imageCallback(canvas, data) {
                    if (canvas instanceof HTMLCanvasElement)
                        canvas.toBlob(blobCallback);
                    else
                        handleError();
                }

                function handleError() {
                    $scope.$apply(function () {
                        Scope.PopupAlert.warn("Warning", "Failed to load image!");
                        uploaded.isLoading = false;
                    });
                }

                function blobCallback(blob) {
                    $scope.$apply(function () {
                        angular.revokeObjectURL(uploaded.image);
                        uploaded.image = angular.createObjectURL(uploaded.blob = blob);
                        uploaded.isLoading = false;
                    });
                }
            }
        }

        if ($routeParams) {

           if ($routeParams.pref) {
              $scope.Tabs.select("Preferences");
           }
           if ($routeParams.pic) {
               $scope.Tabs.select("Picture");
           }
           
           $scope.Content.init();
        }

        $scope.$on('$destroy', function () {
            angular.revokeObjectURL($scope.Content.picture.uploaded.image);
        });
    }
}(angular, app));

